// extracted by mini-css-extract-plugin
module.exports = {"message__list":"Chat_message__list__2k59I","filler":"Chat_filler__1o76a"};